<script>
import component from './base.vue';

export default component.extend({
  computed: {
    disableCustomer: () => false,
    disableProofreader: () => false,
    disableQaExpert: () => false,
  },
});
</script>
